import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";

function BranchList() {
  const navigate = useNavigate();
  const columns = [
    { field: "BL_Id", label: "#" },
    { field: "BL_Name", label: "Branch" },
    { field: "BL_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();


  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.BL_Id));

        navigate(`/BranchLookup/Edit/${encrypted}?${searchParams.toString()}`);
      },
      color: "warning",
    },
  ];
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/Branch/list`}
      actions={actions}
      title={`Branch`}
      linkvalue={`/BranchLookup/Add?${searchParams.toString()}`}
    />
  );
}

export default BranchList;
